export function whatsappShareUrl(roomCode: string, joinUrl: string) {
  const message = `Join my Party Stack game! Room code: ${roomCode}\n${joinUrl}`;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
